import { render, staticRenderFns } from "./MentalLarge.vue?vue&type=template&id=047ccdc3&"
import script from "./MentalLarge.vue?vue&type=script&lang=js&"
export * from "./MentalLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports